import { Tint } from '@/shared/components/typography'

const MapFooter = () => {
  return (
    <div className="sticky top-0 z-99 flex h-[16px] w-full max-w-[768px] border-030 bg-gray-020">
      <div className="flex items-center gap-2">
        <Tint level="tint2" color="text070" weight="medium">
          (주) 쏘카
        </Tint>
        <Tint level="tint2" color="text070" weight="medium">
          사업자등록번호: 616-81-90529, 대표자: 박재욱
        </Tint>
        <Tint level="tint2" color="text070" weight="medium">
          전화번호: 1661-3315
        </Tint>
      </div>
    </div>
  )
}

export default MapFooter
